export default "__VITE_ASSET__Cpcq9Jq3__"